/* Self-contained storefront translations. No language publication or redirects. */
(function () {
  'use strict';
  var dictionaries = window.__pdpI18n || {};
  var keys = window.__pdpI18nKeys || {};
  var locales = window.__pdpI18nLocales || {};
  var sourceLanguage = normalize((window.__pdpLoc || {}).current || document.documentElement.lang || 'en');
  var language = sourceLanguage, country = '', started = false, observer;
  var originals = new WeakMap(), attributes = new WeakMap(), lookupCache = Object.create(null);
  var countryLanguage = {SE:'sv',NO:'nb',FI:'fi',DE:'de',AT:'de',CH:'de',NL:'nl',BE:'nl',FR:'fr',ES:'es',MX:'es',AR:'es',CL:'es',CO:'es',IT:'it',PT:'pt',BR:'pt',PL:'pl'};
  var ignored = 'script,style,noscript,textarea,code,pre,[translate="no"],[data-no-translate]';
  // Curated example identities, never replacements for genuine customer names.
  var placeholderNames = {
    sv:[['Anna','Emma','Sofia','Elsa','Linnea','Maria','Karin','Sara'],['Erik','Johan','Lars','Anders','Oscar','Karl','Nils','Henrik']],
    de:[['Anna','Emma','Hannah','Laura','Lena','Clara','Julia','Marie'],['Lukas','Felix','Paul','Leon','Jonas','Max','Thomas','Lukas']],
    es:[['Lucía','María','Carmen','Ana','Elena','Laura','Isabel','Sofía'],['Pablo','Javier','Carlos','Alejandro','Daniel','Miguel','Diego','Antonio']],
    fi:[['Aino','Sofia','Emma','Ella','Helmi','Liisa','Anna','Maria'],['Eero','Mikko','Juhani','Matti','Lauri','Antti','Juho','Onni']],
    fr:[['Marie','Camille','Léa','Chloé','Julie','Alice','Manon','Louise'],['Thomas','Lucas','Hugo','Louis','Gabriel','Antoine','Julien','Nicolas']],
    it:[['Giulia','Sofia','Anna','Chiara','Francesca','Laura','Elisa','Sara'],['Marco','Luca','Andrea','Matteo','Alessandro','Giuseppe','Lorenzo','Francesco']],
    nb:[['Nora','Emma','Sofie','Ingrid','Anna','Maria','Kari','Hanna'],['Lars','Erik','Ole','Magnus','Henrik','Anders','Oskar','Jonas']],
    nl:[['Emma','Sophie','Julia','Anna','Eva','Lotte','Sanne','Fleur'],['Daan','Lars','Thomas','Bram','Jan','Lucas','Jesse','Sem']],
    pl:[['Anna','Katarzyna','Maria','Zofia','Agnieszka','Ewa','Magdalena','Julia'],['Piotr','Jan','Tomasz','Paweł','Michał','Andrzej','Krzysztof','Adam']],
    pt:[['Maria','Ana','Sofia','Inês','Beatriz','Carolina','Mariana','Joana'],['João','Pedro','Miguel','Tiago','António','Francisco','Diogo','José']]
  };
  function translateIdentity(element) {
    if (!element || !element.hasAttribute('data-pdp-placeholder-name')) return;
    var source=element.getAttribute('data-pdp-placeholder-name'), output=source;
    var pools=owns(placeholderNames,language) ? placeholderNames[language] : null;
    if (source.trim() && pools) {
      var hash=0; for(var i=0;i<source.length;i++) hash=(Math.imul(hash,31)+source.charCodeAt(i))>>>0;
      var style=element.getAttribute('data-pdp-name-style');
      var group=style === 'female' ? 0 : style === 'male' ? 1 : hash%2;
      var pool=pools[group], age=source.match(/,\s*\d{1,3}\s*$/);
      output=pool[hash%pool.length]+(age ? age[0] : '');
    }
    if (element.tagName === 'IMG') { if(element.alt !== output) element.alt=output; }
    else if (!element.children.length && element.textContent !== output) element.textContent=output;
  }
  function normalize(value) { var iso = String(value || '').toLowerCase().split('-')[0]; return iso === 'no' ? 'nb' : iso; }
  function owns(object, name) { return object != null && Object.prototype.hasOwnProperty.call(object, name); }
  function ownString(object, name) { return owns(object, name) && typeof object[name] === 'string' ? object[name] : ''; }
  function supported(iso) { return iso === 'en' || Object.prototype.hasOwnProperty.call(dictionaries, iso); }
  function preference() {
    // A real localized URL is authoritative, including its market and checkout context.
    if (sourceLanguage !== 'en') return sourceLanguage;
    try { if (localStorage.getItem('pdpLangLocked')) return language; } catch (_) {}
    var languages = navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language];
    // Folketsval (Rasul 2026-11-04): a target language anywhere in the device list beats English/others.
    var first = null, target = ['sv','nb','pl','pt'];
    for (var i=0; i<languages.length; i++) { var iso = normalize(languages[i]); if (!supported(iso)) continue; if (target.indexOf(iso) >= 0) return iso; if (!first) first = iso; }
    if (first) return first;
    return countryLanguage[country] && supported(countryLanguage[country]) ? countryLanguage[country] : 'en';
  }
  function substitute(value, vars) {
    if (!vars) return value;
    value = value.replace(/\{\{\s*(\w+)\s*\}\}/g, function (all, name) { return Object.prototype.hasOwnProperty.call(vars, name) ? String(vars[name]) : all; });
    if (value.indexOf('%%') >= 0) {
      var names = Object.keys(vars); if (names.length) value = value.replace(/%%/g, String(vars[names[0]]));
    }
    return value;
  }
  function normalized(value) { return value.toLowerCase().replace(/\s+/g, ' ').trim(); }
  function lookupFor(iso) {
    if (lookupCache[iso]) return lookupCache[iso];
    var input = owns(dictionaries, iso) ? dictionaries[iso] : null;
    var dict = Object.create(null), normal = Object.create(null), patterns = [];
    Object.keys(input || {}).forEach(function (source) {
      if (typeof input[source] !== 'string') return;
      dict[source] = input[source];
      normal[normalized(source)] = dict[source];
      if (/\{\{\s*\w+\s*\}\}/.test(source)) {
        var names = [], pieces = source.split(/(\{\{\s*\w+\s*\}\})/g);
        var pattern = pieces.map(function (piece) {
          var m = piece.match(/^\{\{\s*(\w+)\s*\}\}$/);
          if (m) { names.push(m[1]); return '(.+?)'; }
          return piece.replace(/[.*+?^${}()|[\]\\]/g, '\\$&').replace(/\s+/g, '\\s+');
        }).join('');
        patterns.push({pattern:new RegExp('^'+pattern+'$', 'i'), names:names, target:dict[source]});
      }
    });
    return (lookupCache[iso] = {dict:dict, normal:normal, patterns:patterns});
  }
  function t(value, vars) {
    if (value == null) return '';
    value = String(value);
    var lookup = lookupFor(language), result = lookup.dict[value] || lookup.normal[normalized(value)];
    if (!result) {
      for (var i=0; i<lookup.patterns.length; i++) {
        var entry=lookup.patterns[i], match=value.trim().match(entry.pattern);
        if (match) { var captures=Object.create(null); entry.names.forEach(function(name,j){captures[name]=match[j+1];}); result=substitute(entry.target,captures); break; }
      }
    }
    return substitute(result || value, vars);
  }
  function translateRaw(raw) {
    var match=raw.match(/^(\s*)([\s\S]*?)(\s*)$/), core=match[2], translated=t(core);
    if (translated === core) {
      var phrase=core.match(/^([|·:–—-]\s*)([\s\S]+)$/);
      if (phrase) translated=phrase[1]+t(phrase[2]);
    }
    return match[1]+translated+match[3];
  }
  function eligible(element) { return element && !element.closest(ignored); }
  function translateNode(node) {
    if (!node.nodeValue || !node.nodeValue.trim() || !eligible(node.parentElement) || node.parentElement.hasAttribute('data-pdp-i18n-key')) return;
    var raw=node.nodeValue, record=originals.get(node);
    if (!record || raw !== record.output) record={source:raw,output:raw};
    var output=translateRaw(record.source); record.output=output; originals.set(node,record);
    if (raw !== output) node.nodeValue=output;
  }
  function translateAttributes(element) {
    translateIdentity(element);
    if (!eligible(element)) return;
    var messageKey=element.getAttribute('data-pdp-i18n-key');
    if (messageKey && !element.children.length) {
      var message=key(messageKey); if(element.textContent !== message) element.textContent=message;
    }
    var records=attributes.get(element) || {};
    ['placeholder','title','aria-label','alt'].forEach(function (attr) {
      if (!element.hasAttribute(attr)) return;
      var raw=element.getAttribute(attr), record=records[attr];
      if (!record || raw !== record.output) record={source:raw,output:raw};
      var output=translateRaw(record.source); record.output=output; records[attr]=record;
      if (raw !== output) element.setAttribute(attr,output);
    });
    attributes.set(element,records);
  }
  function apply(root) {
    root=root || document.body; if (!root) return;
    if (root.nodeType === 3) { translateNode(root); return; }
    if (root.nodeType !== 1 && root.nodeType !== 9 && root.nodeType !== 11) return;
    if (root.nodeType === 1) translateAttributes(root);
    var walker=document.createTreeWalker(root,NodeFilter.SHOW_TEXT), node;
    while ((node=walker.nextNode())) translateNode(node);
    if (root.querySelectorAll) root.querySelectorAll('[placeholder],[title],[aria-label],[alt],[data-pdp-i18n-key],[data-pdp-placeholder-name]').forEach(translateAttributes);
  }
  function choose() {
    var chosen=preference(), changed=chosen !== language;
    language=chosen; document.documentElement.lang=chosen; document.documentElement.setAttribute('data-pdp-lang',chosen);
    apply();
    if (changed) document.dispatchEvent(new CustomEvent('pdp:language-change',{detail:{language:language,country:country}}));
  }
  function init() {
    if (started || !document.body) return;
    started=true; choose();
    observer=new MutationObserver(function (changes) {
      changes.forEach(function (change) {
        if (change.type === 'childList') change.addedNodes.forEach(apply);
        else if (change.type === 'characterData') apply(change.target);
        else translateAttributes(change.target);
      });
    });
    observer.observe(document.body,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['placeholder','title','aria-label','alt','data-pdp-placeholder-name','data-pdp-name-style']});
  }
  function key(name,vars) {
    var locale = owns(locales, language) ? locales[language] : null;
    return substitute(ownString(locale, name) || t(ownString(keys, name) || name), vars);
  }
  window.PDP_I18N={t:t,key:key,apply:apply,setCountry:function(code){country=String(code||'').toUpperCase(); if(started)choose();},init:init,get language(){return language;}};
  window.pdpLockLanguage=function(){try{localStorage.setItem('pdpLangLocked','1');}catch(_){}};
  // Password and other standalone layouts may load this module without theme.js.
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
})();
